<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left" :style="{ visibility: render ? 'visible' : 'hidden' }">
        <div class="input-v2">
          <el-input v-model="queryParams.costCentName" placeholder="请输入搜索大区" @keyup.enter.native="getCusIds"></el-input>
        </div>
        <select-cus @change="cusChange" :selected="selectedCusIds"></select-cus>
        <div class="date-picker-v2">
          <el-date-picker class="query-date-picker" v-model="wageMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('from')" :end-placeholder="$t('to')" ></el-date-picker>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.emp" :key="item.id" :value="item.idCard" :label="item.empName" />
          </el-select>
        </div>
        <div class="select-v2">
          <el-select class="query-select" v-model="queryParams.taxTypes" multiple collapse-tags :placeholder="$t('selectTaxType')" filterable clearable @visible-change="handleSelectVisibleChange">
            <el-option v-for="item in dictData.taxType" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName" />
          </el-select>
        </div>
        <div v-if="false" class="date-picker-v2">
          <el-date-picker v-model="queryParams.wageMonths" type="months" format="yyyy-MM" value-format="yyyy-MM" :placeholder="$t('salaryMonth')" prefix-icon="none" ></el-date-picker>
          <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
        </div>
        <el-button type="primary" class="button-v2" @click="handleSearch">{{ $t('query') }}</el-button>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">{{ $t('export') }}</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        v-if="render"
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        :show-operation="false"
        align="center"
        :columns="columns"
        :data="tableData"
        show-footer
        :footer-method="footerMethod"
        @change-filter="changeFilter"
      ></air-table>
      <bsp-pagination :pager-config.sync="queryParams" @page-change="getData" @page-size-change="pageSizeChange" show-page-size></bsp-pagination>
    </div>

    <el-dialog
      class="modal-v2 has-padding"
      width="800px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('displayItemConfiguration')"
      :visible.sync="customHeaderModalShow"
      append-to-body
    >
      <customHeader :header-list.sync="headerList" report-type="员工收入明细表"></customHeader>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="customHeaderModalShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveCustomHeader">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import * as api from '@/api/v2/stats/emp-income'
import {queryEmpInfoListPage} from '@/api/v2/common'
import exportMethod from '@/util/export'
import customHeader from '@/components/v2/custom-header'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
import {updataCustHeaderInfo} from '@/api/wage/pay'
import { mapGetters } from 'vuex';
import { randomLenNum,floatSumArray,downloadFileByUrl } from '@/util/util';
import { validatenull } from '@/util/validate';

export default {
  name: 'EmpIncomeDetail',
  components: {
    customHeader,
    SelectCus
  },
  data() {
    return {
      render: false,
      loading: true,
      wageMonthRange: [],
      isSelectChange: false,
      queryParams: {
        startDate: undefined,
        endDate: undefined,
        idCards: [],
        costCenters: [],
        costCentName:'',
        taxTypes: [],
        // wageMonths: [],
        cusIds: [],
        page: 1,
        limit: 20,
        total: 0
      },
      limitCustom: 1,
      dictMap: {},
      dictData: {
        emp: [],
        costCenter: [],
        taxType: []
      },
      columns: [],
      tableData: [],
      submitLoading: false,
      customHeaderModalShow: false,
      headerList: [],
      selectedCusIds: []
    }
  },
  computed: {
    ...mapGetters(['cusListTotal'])
  },
  created() {
    const storeParams = this.$getStore('empIncomeDetail_queryParams')
    if (storeParams) {
      // 如果缓存中有参数，则说明是从汇总点击查看明细而来
      this.queryParams = storeParams
      this.$removeStore('empIncomeDetail_queryParams')
    }
    this.init()
  },
  methods: {
    init() {
      this.queryParams.cusId = this.$userInfo.cusId
      this.getData()
    },
    getData() {
      this.render = false
      this.loading = true
      if (this.$isNotEmpty(this.wageMonthRange)) {
        this.queryParams.startDate = this.wageMonthRange[0]
        this.queryParams.endDate = this.wageMonthRange[1]
      } else {
        this.queryParams.startDate = undefined
        this.queryParams.endDate = undefined
      }
      api.selectDataForSalaryDetail(this.queryParams).then(res => {
        const data = res.data.data
        data.customList.forEach(item => {
          item.minWidth = 140
          if (item.field === 'empName' || item.field === 'identityNum') {
            item.fixed = 'left'
            item.filterType = 'input'
          }
        })
        this.columns = data.customList
        data.translates.forEach(item => {
          if(item.dictMap!=undefined) {
          this.dictMap[item.field] = this.$arrayToObj(item.dictMap, 'codeItemId')
          }
        })
        if (!this.dictMap.taxType) {
          this.dictMap.taxType = this.$arrayToObj(data.taxType, 'codeItemId')
        }
        this.tableData = this.$handleTableDict(data.dataList, this.dictMap, '')
        this.queryParams.total = data.params.total
        this.dictData.costCenter = data.costCenter
        this.dictData.taxType = data.taxType
        this.render  = true
        this.loading = false
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    getCusIds() {
      queryEmpInfoListPage({costCentName:this.queryParams.costCentName, limit: 100000}).then(res => {
        const { cusIds } = res.data.condition
        const { records, condition } = res.data
        this.selectedCusIds = condition.cusIds
        this.dictData.emp = records
        this.queryParams.idCards = []
      })
    },
    getEmpList() {
      queryEmpInfoListPage({cusId: this.$userInfo.cusId,costCentName:this.queryParams.costCentName,cusIds:this.queryParams.cusIds, limit: 100000}).then(res => {
        const { records } = res.data
        this.dictData.emp = records
        this.queryParams.idCards = []
      })
    },
    handleSelectChange(val) {
      if (this.$isEmpty(val)) {
        // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
        this.getData()
        this.isSelectChange = false
      } else {
        this.isSelectChange = true
      }
    },
    handleSelectVisibleChange(val) {
      // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
      if (!val && this.isSelectChange) {
        this.getData()
        // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
        this.isSelectChange = false
      }
    },
    saveCustomHeader() {
      if (this.$isEmpty(this.headerList)) {
        this.$msgError('显示项目不能为空')
        return
      }
      let param = {
        headers: this.headerList,
        reportType: '员工收入明细表'
      }
      this.submitLoading = true
      updataCustHeaderInfo(param).then(res => {
        if (res.data.code === 0) {
          this.customHeaderModalShow = false
          this.$msgSuccess('保存成功')
          this.getData()
        }
      }).finally(() => this.submitLoading = false)
    },
    handleSearch() {
      this.getData()
    },
    handleExport() {
      this.$msgInfo(`${ this.$t('startDownloading') }...`);
      api.getCusRelDataForSalaryDetailForExport(this.queryParams).then(res => {
        let fileId = res.data.downloadPath;
        let randomNum = randomLenNum("16", new Date());
        if (fileId) {
          downloadFileByUrl(fileId, randomNum + '.xlsx')
        }
      })
    },
    // 客户筛选change事件
    cusChange({ data, checkedLabels, checkedValues }) {
      this.queryParams.cusIds = checkedValues;
      this.getEmpList()
      this.getData();
    },
    numToArray(list, field) {
      return list.map(item => {
        return validatenull(item[field]) ? 0 : item[field];
      })
    },
    sumNum (list, field) {
      const numArray = this.numToArray(list, field);
      return floatSumArray(numArray);
    },
    footerMethod ({ columns, data }) {
      let _this = this;
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '合计';
          } else {
            if (!validatenull(column.params)) {
              const { valueType } = column.params;
              if (valueType == '92420001' || valueType == '92420002') {
                return this.sumNum(data, column.property)
              }
              return null
            } else {
              return null
            }
          }
        })
      ]
    },
    // 输入框回车，调接口
    pageSizeChange(val) {
      this.queryParams = Object.assign(val);
      this.getData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.app-container-v2.table-container-v2 {
  padding: 24px;
  box-sizing: border-box;
}

.title-box {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  // 和表格紧贴，不产生多余空隙（解决你刚才间距变大的问题）
  margin-bottom: 0;
  // 整体空间不足时，左右两块整体换行
  flex-wrap: wrap;

  .title-left {
    display: flex;
    align-items: center;
    // 筛选控件之间统一间距
    gap: 16px;
    // 关键：优先挤压缩放，而不是内部直接换行
    flex: 1 1 auto;
    min-width: 0;
    // 内部控件【禁止自动换行】放大页面时保持一排
    flex-wrap: nowrap;

    .input-v2,
    .date-picker-v2,
    .select-v2 {
      // 给控件最小宽度，防止被挤扁到看不清
      min-width: 160px;
      flex: 0 0 auto;
    }
  }

  .title-right {
    flex: 0 0 auto;
    white-space: nowrap;
  }
}

.table-body {
  padding: 0;
  margin-top: 0;
  .air-table {
    margin-top: 0;
  }
}
</style>

